module.exports = __webpack_public_path__ + "img/icon-ranking-4@2x.73c2e02a.png";